export default __webpack_public_path__ + "static/media/casual-colorful-cute-667208.9188deaf.jpg";